module.exports = __webpack_public_path__ + "/img/Molded-Body-Labeled-sZ7ne5.svg";